import $ from "jquery";

const obstacle_loop = () => {
  const util = () => {
    obstacle_loop_function();
  };

  const obstacle_loop_function = () => {
    const btn = $("#obstacle-loop-btn");
    const item = $(".obstacle-loop_wrapper_item");

    $(document).ready(function () {
      btn.addClass("not-active");
      item.slice(4).hide();
    });

    btn.on("click", function () {
      item.slice(4).toggle(300);

      toggleButton();
    });

    const toggleButton = () => {
      btn.toggleClass("not-active");
      btn.toggleClass("active");
    };
  };

  util();
};
try {
  obstacle_loop();
} catch (error) {
  console.error(error);
}
